const ROOT = 'AGENCY_CONTRACT_V2_PICKERS_';

const actionTypes = {
  LOAD_AGENCIES_REQUEST: `${ROOT}LOAD_AGENCIES_REQUEST`,
  LOAD_AGENCIES_SUCCESS: `${ROOT}LOAD_AGENCIES_SUCCESS`,
  LOAD_AGENCIES_ERROR: `${ROOT}LOAD_AGENCIES_ERROR`,
  LOAD_ENGINES_REQUEST: `${ROOT}LOAD_ENGINES_REQUEST`,
  LOAD_ENGINES_SUCCESS: `${ROOT}LOAD_ENGINES_SUCCESS`,
  LOAD_ENGINES_ERROR: `${ROOT}LOAD_ENGINES_ERROR`,
  LOAD_UNITS_REQUEST: `${ROOT}LOAD_UNITS_REQUEST`,
  LOAD_UNITS_SUCCESS: `${ROOT}LOAD_UNITS_SUCCESS`,
  LOAD_UNITS_ERROR: `${ROOT}LOAD_UNITS_ERROR`,
  LOAD_STATES_REQUEST: `${ROOT}LOAD_STATES_REQUEST`,
  LOAD_STATES_SUCCESS: `${ROOT}LOAD_STATES_SUCCESS`,
  LOAD_STATES_ERROR: `${ROOT}LOAD_STATES_ERROR`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actionTypes;
